import { CLEAR_STUDENT_DATA } from '../../actions/student';

import {
  FETCH_PLACEMENT_SENT,
  FETCH_PLACEMENT_SUCCEEDED,
  FETCH_PLACEMENT_FAILED,
  CREATE_PLACEMENT_SENT,
  CREATE_PLACEMENT_SUCCEEDED,
  CREATE_PLACEMENT_FAILED,
  UPDATE_PLACEMENT_SENT,
  UPDATE_PLACEMENT_SUCCEEDED,
  UPDATE_PLACEMENT_FAILED,
} from '../../actions/placement';

const initialState = {
  placement: null,
  loading: false,
  mutating: false,
};

export default function studentPlacementReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_STUDENT_DATA:
      return initialState;
    case FETCH_PLACEMENT_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PLACEMENT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        placement: payload.placement,
      };
    case FETCH_PLACEMENT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_PLACEMENT_SENT:
    case UPDATE_PLACEMENT_SENT:
      return {
        ...state,
        mutating: true,
      };
    case CREATE_PLACEMENT_SUCCEEDED:
    case UPDATE_PLACEMENT_SUCCEEDED:
      return {
        ...state,
        mutating: false,
        placement: payload.placement,
      };
    case CREATE_PLACEMENT_FAILED:
    case UPDATE_PLACEMENT_FAILED:
      return {
        ...state,
        mutating: false,
      };
    default:
      return state;
  }
}
